import { ENVIRONMENT } from '@aca-new/environments/environment';

declare let ENV_TYPE: 'dev' | 'pp' | 'staging' | 'staging_cert' | 'prod';
declare let SERVER_URL_CONFIG: string;
declare let SERVER_URL_CONFIG_CN: string;

export const SERVER_URL = location.origin.includes('qima.cn') ? SERVER_URL_CONFIG_CN : SERVER_URL_CONFIG;

export const ANONYMOUS_USER = 'Anonymous';

export const {
  MARKETING_WEBSITE_URL,
  MARKETING_WEBSITE_APP_LINK,
  SAMPLING_LEVELS_URL,
  REFERENCE_SAMPLES,
  SQF_REGISTRATION_URL,
  SQF_GUIDANCE_DOCUMENTS_URL,
  GOOGLE_MAP_URL,
  CONDITIONS_URL,
  TABLEAU_URL,
  INTERNAL_DOMAINS,
  ABOUT_QIMA,
  OUR_SERVICES,
  CONTACT_US,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  LINKEDIN,
  TWITTER,
  WECHAT,
  YOUTUBE,
  APPLE_STORE,
  PLAY_STORE,
  FACEBOOK,
  INSTAGRAM,
  REGISTER,
  REGISTER_CN,
  ICP_LICENSE,
} = ENVIRONMENT[ENV_TYPE];
